<template>
		<div class="">
      <div class="">
          <div class="nav title-bg" style="margin-top:30px;">
            <span class="">{{$t('DailyRewards')}}</span>
          </div>
          <div class="daily-login-list mt20">
            <div class="daily-li" v-for="(item,index) in dailyList" :class="{'active':item.status==0,'dailyd12':item.status==3,'daily-li2':index==6}" @click="getMissed(item)">
              <div class="num">Day {{item.sign_day}}</div>
              <div class="lock" v-if="item.status==3">
                <img src="../../static/images/lock.png">
              </div>
              <div class="img">
                <img :src="item.image" />
              </div>
              <div class="t">{{item.title}}</div>
              <div class="Missed disflex" v-if="item.status==2"><img height="50" src="../../static/images/miss.png">{{$t('Missed')}}</div>
              <div class="dailyd disflex" v-if="item.status==1"><img src="../../static/images/dailyd.png"></div>
              <div class="dailyd dailyd2 disflex" v-if="item.status==3"></div>
            </div>
          </div>
          <div class="mt20" style="">
            <button class="btn btn-green font-family fw7" @click="getClaim()"><span>{{$t('Claim')}}</span></button>
          </div>
      </div>
      <Dialog ref="answerDialog" type="alert" :callback="answerModal" title="" width="100" :modalFoot="false">
          <div class="" slot="mdBox" >
            <div class="answer-modal daily-modal">
              <div style="width:90%;margin:0 auto">
                <div class="">
                  <div class="fs50 font-family dui">{{$t('ReClaim')}}</div>
                  <img class="big-img" :src="info.image" />
                  <div class="daliy-t">
                    {{info.tip}}
                  </div>
                  <div class="answer-t2">
                    <div class="fw7">{{$t('DailyLoginT2')}}</div>
                    {{$t('DailyLoginT3')}}
                  </div>
                  <button class="btn6 font-family mt20" style="width: 280px;line-height: 103px;color: #fff;font-size: 30px;" @click="cancelModal">{{$t('cancel')}}</button>
                  <button style="width: 280px;height: 104px;" class="btn-yl font-family mt20" @click="answerModal">{{$t('yesClaim')}}</button>
                </div>
              </div>
            </div>
          </div>
      </Dialog>
		</div>
</template>
<script>
import Dialog from './dialog'
export default {
  props: {
      message: {
        type: String,   // 类型校验
        default: '默认值' // 默认值（可选）
      },
  },
  components:{
  Dialog
  },
  data() {
    return {
      info:{},
      dailyList:[],
      parent:null
    }
  },
  created(){
    if(this.message=='2'){
      this.parent = this.$parent.$parent
    }else{
        this.parent = this.$parent.$parent.$parent
    }
    this.getHome();
  },
  methods: {
		back(){
			this.$router.push({path:'/'})
		},
    answerModal(){
      let that = this;
      that.parent.loadModal(true);
      that.$api.post('/api/sign/buy_sign_card',null,r =>{
        if(r.msg) that.$utils.alertText(r.msg);
        that.parent.returnCode(r,function(){
            that.parent.loadModal(false);
            that.getClaim(that.info)
        });

      })
    },
    getMissed(item){
      if(item.status!=2){
        if(item.status==0){
          this.getClaim()
        }else{
          this.$utils.alertText(item.tips2);
        }
        return;
      }
      this.info = item
      this.$refs.answerDialog.showMaskFun();
    },
    cancelModal(){
      this.$refs.answerDialog.closeMask();
    },
		getHome(){
			let that =this;
      console.log(that.parent.$parent.$parent)
			that.parent.loadModal(true);
			that.$api.get('/api/sign/list',null,r =>{
				that.parent.returnCode(r,function(){
          that.parent.loadModal(false);
          that.dailyList = r.data
        });

			})
		},
    getClaim(item){
      let that = this;
      let data = null
      if(item){
         data = {
          sign_date:item.sign_date,
          is_repair:1
        }
      }
			that.parent.loadModal(true);
      that.$api.post('/api/sign/signin',data,r =>{
        if(r.msg) that.$utils.alertText(r.msg);
      	that.parent.returnCode(r,function(){
          that.parent.loadModal(false);
          that.getHome()
          that.$emit("child-event", true);
          that.$refs.answerDialog.closeMask();
        });

      })
    }
	}
}
</script>
<style>
  .title-bg{background: url(../../static/images/title-bg.png) no-repeat center  0;color:#fff;text-shadow: 3px 2px 0 #1f0f00;padding-bottom: 70px;}
  .daily-login-list{display: flex;flex-wrap: wrap;justify-content: center;}
  .daily-li{width: calc(33.33% - 20px);margin: 0 10px 18px;background: #02defe;border-radius: 20px;position: relative;border:3px solid #ffffff00;min-height: 210px;box-shadow: 0px 10px 10px inset #fff;}
  .daily-li .img{width: 100%;}
  .daily-li .img img{width:100px;margin-top: 10px;}
  .daily-li .num{font-weight: 700;font-size:24px;padding: 5px 10px;line-height: 24px;position: absolute;left: 7px;top: 5px;z-index: 9;background: #5d17eb;border: 2px solid #fff;border-radius: 30px;}
  .daily-li .t{color: #ffffff;text-shadow: 3px 2px 0 #1f0f00;font-size: 24px;font-weight: 700;position: absolute;bottom: 8px;letter-spacing: -1px;width: 100%;border-radius: 0 0 15px 15px;z-index: 12;line-height: 30px;}
.lock{position: absolute;top:-15px;right: -15px;}
  .daily-li2{width: 100%;background: #fac52e;}
  .daily-li2 .img img{width: 150px;}
  .daily-li2 .img{margin-top: 0;}
  .daily-login{padding: 20px 0px 70px;}
  .Missed,.dailyd{position: absolute;top: 0;width: 100%;height: calc(100%);background: #ff1364;border-radius: 20px;font-size: 20px;justify-content: center;}
  .Missed img{vertical-align: middle;margin-right: -24px;}
  .daily-li.active{border: 3px solid #fff;background: #50f761;}
  .dailyd{background: #94427273;}
  .dailyd2{background: #ffffff00;}
  .dailyd12 .num,.dailyd12 .t{opacity: 1;}
  .dailyd img{width: 80px;}
  .daliy-t{background: #fff;color:#002592;border:2px solid #ffde35;border-radius: 200px;padding:10px 0;margin-top: -20px;}
  .daily-modal{}
  .big-img{width: 450px;margin: -20px;}
  .daily-modal2{width: 720px;padding: 15px 0px 0;margin: 0 auto;}

</style>



// WEBPACK FOOTER //
// src/components/dailyLogin.vue